import { zodResolver } from '@hookform/resolvers/zod';
import * as React from 'react';
import { useForm } from 'react-hook-form';
import * as z from 'zod';
import { CodeSchema } from '../../../utils/schema';
import { CognitoErrorCodesEnum } from '../../../utils/types/eunms';
import { SimpleLayout } from '../../layouts/simple-layout';
import { CodeInput } from '@components/molecules/inputs/prebuilts/code-input';
import type { ResponseResult } from '@utils';
import { WithControl } from '@utils';

export type ConfirmLabels = {
	subtitle: string;
	title: string;
	label: string;
	submit: string;
	sendNewCodeMessage: string;
	sendNewCodeButton: string;
};

type ConfirmFormProps = {
	labels: ConfirmLabels;
	onSubmit: (data: { code: string }) => Promise<ResponseResult<any>>;
	onRequestNewCode: () => void;
};

const schema = z.object({
	code: CodeSchema,
});

export const ConfirmForm: React.FC<ConfirmFormProps> = ({ labels, onSubmit, onRequestNewCode }) => {
	const {
		handleSubmit,
		formState: { isValid, isSubmitting },
		control,
		setError,
	} = useForm({
		defaultValues: {
			code: '',
		},
		resolver: zodResolver(schema),
	});

	const onSubmitForm = async (data: any) => {
		const { error, result } = await onSubmit(data);

		if (error?.code === CognitoErrorCodesEnum.CODE_MISMATCH || error?.code === CognitoErrorCodesEnum.EXPIRED_CODE) {
			setError('code', { message: error.message });
		}
	};

	const ControlledCodeInput = WithControl(CodeInput, control);

	return (
		<SimpleLayout
			title={labels.title}
			subtitle={labels.subtitle}
			submitButton={labels.submit}
			linkButton={labels.sendNewCodeButton}
			linkText={labels.sendNewCodeMessage}
			handleSubmit={handleSubmit(onSubmitForm)}
			isValid={isValid}
			onLinkClick={onRequestNewCode}
			isLoading={isSubmitting}
		>
			<ControlledCodeInput label={labels.label} name="code" />
		</SimpleLayout>
	);
};
